import { create } from 'zustand';

export interface PaletteCommand {
  id: string;
  title: string;
  subtitle?: string;
  icon?: string;
  group?: string;
  keywords?: string[];
  run: () => void;
}

export interface PaletteState {
  open: boolean;
  query: string;
  commands: PaletteCommand[];
  toggle: () => void;
  openPalette: () => void;
  closePalette: () => void;
  setQuery: (q: string) => void;
  register: (cmd: PaletteCommand) => () => void;
  filtered: () => PaletteCommand[];
}

export const usePaletteStore = create<PaletteState>((set, get) => ({
  open: false,
  query: '',
  commands: [],
  toggle: () => set((s) => ({ open: !s.open, query: s.open ? '' : s.query })),
  openPalette: () => set({ open: true }),
  closePalette: () => set({ open: false, query: '' }),
  setQuery: (query) => set({ query }),
  register: (cmd) => {
    set((s) => ({ commands: [...s.commands.filter((c) => c.id !== cmd.id), cmd] }));
    return () => set((s) => ({ commands: s.commands.filter((c) => c.id !== cmd.id) }));
  },
  filtered: () => {
    const { query, commands } = get();
    if (!query.trim()) return commands;
    const q = query.toLowerCase();
    return commands.filter((c) =>
      c.title.toLowerCase().includes(q) ||
      c.subtitle?.toLowerCase().includes(q) ||
      c.keywords?.some((k) => k.toLowerCase().includes(q))
    );
  }
}));
